{
  "app": {
    "name": "WebTemplate",
    "tagline": "Modèle SaaS Moderne"
  },
  "nav": {
    "dashboard": "Tableau de bord",
    "settings": "Paramètres",
    "admin": "Administration",
    "users": "Utilisateurs",
    "logout": "Déconnexion",
    "profile": "Profil",
    "home": "Go to dashboard",
    "sidebarLabel": "Sidebar navigation",
    "mainLabel": "Main navigation",
    "mobileLabel": "Mobile navigation",
    "mobileMenuLabel": "Mobile navigation menu",
    "collapseSidebar": "Collapse sidebar",
    "expandSidebar": "Expand sidebar",
    "openMenu": "Open navigation menu",
    "userMenu": "User menu"
  },
  "settings": {
    "account": {
      "title": "Account",
      "description": "Manage your profile, personal details, and preferences.",
      "profileTitle": "Profile",
      "profileDescription": "Your identity across the platform.",
      "firstNameLabel": "First name",
      "lastNameLabel": "Last name",
      "emailLabel": "Email address",
      "emailHint": "Used for sign-in and account notifications.",
      "notSet": "Not set",
      "statusLabel": "Account status",
      "memberSinceLabel": "Member since",
      "preferencesTitle": "Preferences",
      "preferencesDescription": "Tailor the interface to how you work.",
      "languageLabel": "Language",
      "languageHint": "Changes the language used across the app."
    },
    "security": {
      "title": "Security",
      "description": "Manage your password and protect your account.",
      "passwordTitle": "Password",
      "passwordDescription": "Set a strong, unique password to keep your account secure.",
      "passwordHint": "Send yourself a reset link to choose a new password.",
      "changePassword": "Change password",
      "twoFactorTitle": "Two-factor authentication",
      "twoFactorDescription": "Add a second step at sign-in for an extra layer of protection.",
      "twoFactorDisabled": "Not enabled",
      "twoFactorHint": "Use an authenticator app to generate one-time codes.",
      "enableTwoFactor": "Enable two-factor",
      "sessionsTitle": "Active sessions",
      "sessionsDescription": "Devices currently signed in to your account.",
      "sessionsEmptyTitle": "No other active sessions",
      "sessionsEmptyDescription": "When you sign in from another device, it will show up here."
    }
  },
  "admin": {
    "clearFilters": "Clear filters",
    "loadError": "We couldn't load this data. Try again in a moment.",
    "users": {
      "noResultsTitle": "No matching users",
      "noResultsDescription": "No users match your current search and filters."
    },
    "featureFlags": {
      "emptyTitle": "No feature flags yet"
    }
  },
  "actions": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "create": "Créer",
    "search": "Rechercher",
    "loading": "Chargement...",
    "confirm": "Confirmer",
    "back": "Retour",
    "next": "Suivant",
    "submit": "Soumettre",
    "retry": "Réessayer"
  },
  "account": {
    "status": {
      "active": "Actif",
      "disabled": "Désactivé",
      "inactive": "Inactif",
      "locked": "Verrouillé",
      "pending": "Vérification en attente"
    },
    "role": {
      "superAdmin": "Super-administrateur",
      "admin": "Administrateur",
      "user": "Utilisateur"
    }
  },
  "language": {
    "label": "Langue",
    "en": "Anglais",
    "es": "Espagnol",
    "fr": "Français"
  }
}
